import {
  RunFlatToggle,
  TireTypePicker,
  Title,
  TireLocationPicker,
  TireSizeSelector,
  InputChassie,
} from '@/components';

import {
  isValidChassie,
} from '@/utils';

import validationFlow from '@/validation-flow';

import {
  mapGetters,
  mapActions,
  mapMutations,
} from 'vuex';

export default {
  name: 'step5TireInfoMobileRegion',
  components: {
    [RunFlatToggle.name]: RunFlatToggle,
    [TireTypePicker.name]: TireTypePicker,
    [Title.name]: Title,
    [TireLocationPicker.name]: TireLocationPicker,
    [TireSizeSelector.name]: TireSizeSelector,
    [InputChassie.name]: InputChassie,
  },
  props: {},
  data: () => ({
    chas: '',
  }),
  computed: {
    ...mapGetters('appointment', {
      tireType: 'getTireType',
      tireLocations: 'getTireLocations',
      bodyworkType: 'getBodyworkType',
      tireSizes: 'getTireSizes',
      serviceType: 'getServiceType',
      getChassie: 'getChassie',
    }),
    ...mapGetters('garage', {
      garages: 'getGarages',
      tireCodes: 'getTireCodes',
    }),
    requiredImageUrl() {
      return require(
        '@/assets/images/logo/chassis.jpg',
      );
    },
    chassie: {
      get() {
        return this.getChassie;
      },
      set(newChassie) {
        this.setChassie = newChassie;

        return newChassie;
      },
    },
    isValidTireInfo() {
      // Check als ze 4 banden hebben volgens tiretype & cartype
      let stockOrActive = 0;
      const tireLocations = ['t1l1', 't1r1', 't2l2', 't2l1', 't2r1', 't2r2'];

      tireLocations.forEach(tireLocation => {
        const stockProperty = `${this.tireType}Stock`;
        const stockState = this.tireLocations[tireLocation][stockProperty];
        // 2 active, 3 stock
        if (stockState === 2 || stockState === 3) {
          stockOrActive += 1;
        }
      });

      let correctAmountOfTires = (this.bodyworkType === 'car' && stockOrActive === 4) ||
        (this.bodyworkType === 'bus' && stockOrActive === 6);

      // Bij nieuwe banden moet de stock niet /4 of /6 zijn
      if (this.serviceType === 'new-tires' && stockOrActive > 0) {
        correctAmountOfTires = true;
      }

      // Check size on ax where there is an active tire
      const frontAxisTireLocations = ['t1l1', 't1r1'];
      const backAxisTireLocations = ['t2l2', 't2l1', 't2r1', 't2r2'];

      let hasFrontAxisTire = false;
      let hasBackAxisTire = false;

      frontAxisTireLocations.forEach(tireLocation => {
        const stockProperty = `${this.tireType}Stock`;
        const stockState = this.tireLocations[tireLocation][stockProperty];
        // 2 active, 3 stock
        if (stockState === 2 && stockState !== 1) {
          hasFrontAxisTire = true;
        }
      });

      backAxisTireLocations.forEach(tireLocation => {
        const stockProperty = `${this.tireType}Stock`;
        const stockState = this.tireLocations[tireLocation][stockProperty];
        // 2 active, 3 stock
        if (stockState === 2 && stockState !== 1) {
          hasBackAxisTire = true;
        }
      });

      const properties = ['width', 'height', 'diameter', 'loadCapacity', 'speedIndex'];
      let correctFrontSizes = true;
      let correctBackSizes = true;

      if (hasFrontAxisTire) {
        properties.forEach(property => {
          if (this.tireSizes.frontTire[property] === 0 ||
            this.tireSizes.frontTire[property] === '') {
              correctFrontSizes = false;
          }
        });
      }

      if (hasBackAxisTire) {
        properties.forEach(property => {
          if (this.tireSizes.backTire[property] === 0 ||
            this.tireSizes.backTire[property] === '') {
              correctBackSizes = false;
          }
        });
      }

      const correctChassie = isValidChassie(this.chassie);

      return correctAmountOfTires && correctFrontSizes && correctBackSizes && correctChassie;
    },
  },
  methods: {
    goToPreviousStep() {
      this.$router.push({
        name: 'step2VehiculeType',
      });
    },
    ...mapMutations('appointment', {
      setChassie: 'SET_CHASSIE',
    }),
    makeAppointment() {
      if (this.isValidTireInfo) {
        validationFlow.validateStep5TireInfoMobileRegion();
      }
    },
    ...mapActions('garage', {
      getGarages: 'SEARCH_GARAGES',
      getTireCodes: 'FETCH_DATA_TIRECODES',
    }),
  },
  beforeMount() {
    if (this.tireCodes.length === 0) {
      this.getTireCodes();
    }
  },
};
